import * as NUMBER from 'constant/number'
import React from 'react'
import { Modal, Tabs } from 'antd'
import LegalPolicy from 'view/component/legal-policy'
import DeploymentInformation from 'view/component/deployment-information'
import PropTypes from 'prop-types'
import styles from './index.scss'

const { TabPane } = Tabs

const AboutPage = ({ isModalVisible, handleClose, handleOpen }) => {
  return (
    <Modal
      bodyStyle={{ paddingLeft: '10px' }}
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
      className={styles.aboutModal}
      okText='Close'
      onCancel={handleClose}
      onOk={handleClose}
      title='Terms & Conditions'
      visible={isModalVisible}
      width={800}
    >
      <Tabs tabPosition={window.innerWidth < NUMBER.SEVEN_SIX_EIGHT ? 'top' : 'left'}>
        <TabPane
          key='1'
          tab='Legal Policy'
        ><LegalPolicy /></TabPane>
        <TabPane
          key='2'
          tab='Deploy Version'
        ><DeploymentInformation /></TabPane>
      </Tabs>
    </Modal>
  )
}

AboutPage.propTypes = {
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
  isModalVisible: PropTypes.bool
}

export default AboutPage
